// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebase: {
    projectId: 'amagcr',
    appId: '1:915813264829:web:e4c48845dba9b9e13436d4',
    storageBucket: 'amagcr.appspot.com',
    apiKey: 'AIzaSyB04m4CBhxfTxmnu-mQp4lvRNqgOsLA5zQ',
    authDomain: 'amagcr.firebaseapp.com',
    messagingSenderId: '915813264829',
    measurementId: 'G-F9FX1VX0K1',
  },
  production: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
